"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledIconBlock = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 2rem;\n  width: 100%;\n  border-radius: ", ";\n  padding: 0 0.75rem 0 0.5rem;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.isSuccess ? p.theme.colorSuccess : "#ecf0f5";
}, function (p) {
  return p.isSuccess ? p.theme.colorSuccessText : p.theme.colorText;
});

var StyledIconBlockIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  margin: 0 0.25rem 0 0.35rem;\n  color: ", ";\n"])), function (p) {
  return p.isSuccess ? p.theme.colorSuccessText : p.theme.colorText;
});

var StyledIconBlockText = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  transform: translateY(-1px);\n"])));

var StyledIconBlockLabel = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 0.425rem;\n  white-space: nowrap;\n  text-align: center;\n  color: ", ";\n"])), function (p) {
  return (0, _polished.rgba)(p.isSuccess ? p.theme.colorSuccessText : p.theme.colorText, 0.67);
});

var StyledIconBlockValue = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  text-align: center;\n  white-space: nowrap;\n"])));

var Wrapper = function Wrapper(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      value = _ref.value,
      isSuccess = _ref.isSuccess;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledIconBlock, {
    isSuccess: isSuccess,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconBlockIcon, {
      isSuccess: isSuccess,
      children: icon
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledIconBlockText, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconBlockLabel, {
        isSuccess: isSuccess,
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIconBlockValue, {
        children: value
      })]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;